import moment from "moment"
import { useContext, useState } from "react"
import { Card } from "react-bootstrap"
import DatePicker from "react-datepicker"
import { Calendar } from "react-feather"
import { SystemMessageContext } from "../../../context/SystemMessageContext"
import campaignStatuses from "../../../data/campaignStatuses"
import callAPI from "../../../helpers/callAPI"
import CustomButton from "../../../templates/UI/CustomButton/CustomButton"


const ScheduleRelaunchContent = ({ isOpen, handleClose, campaignId, refetch }) => {

    const { showSystemMessage } = useContext(SystemMessageContext)
    const [submitting, setSubmitting] = useState(false)
    const [date, setDate] = useState('')

    const handleSubmit = (e) => {
        e.preventDefault()

        const body = {
            status: e.target.status.value,
            date: date
        }

        setSubmitting(true)

        callAPI(`campaign/${campaignId}/scheduleRelaunch`, 'POST', body)
            .then(result => {
                if (result["success"] === true) {
                    showSystemMessage('success', result.message)
                    handleClose()
                    refetch(date, campaignStatuses.campaignStatuses.filter(status => status.value === e.target.status.value)[0].text)
                } else if (result["success"] === false) {
                    showSystemMessage('error', result.errors.message)
                    setSubmitting(false)
                }
            }).catch((error) => {
                showSystemMessage('error', error.message)
                setSubmitting(false)
            })
    }

    const handleDateChange = (date) => {
        let s = document.getElementById('date_time').setCustomValidity('')
        setDate(date)
    }

    return (
        <Card>
            <form onSubmit={handleSubmit}>
                <Card.Header closeButton>
                    <h1 className="mb-h1-dark">Schedule Campaign Relaunch </h1>
                </Card.Header>
                <Card.Body>
                    <table className="table table-borderless">
                        <tbody>
                            <tr>
                                <td>Status:</td>
                                <td>
                                    <select className="form-control w-50" name="status" required>
                                        <option value=""></option>
                                        {campaignStatuses.campaignStatuses.map(status => {
                                            if (status.value === 'A' || status.value === 'B' || status.value === 'H'){
                                                return <option key={status.value} value={status.value}>{status.text}</option>
                                            }                                            
                                        })}
                                    </select>
                                </td>
                            </tr>
                            <tr>
                                <td>Relaunch On:</td>
                                <td>
                                    <DatePicker
                                        placeholderText='Select Date & Time'
                                        className='form-control'
                                        selected={date}
                                        minDate={moment().toDate()}
                                        showTimeSelect
                                        dateFormat="yyyy/MM/dd HH:mm:ss"
                                        onChange={(date) => handleDateChange(date)} id="date_time" required autoComplete="off" /><Calendar size={16} color="#007bff" />
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </Card.Body>
                <Card.Footer>
                    <CustomButton name="Schedule" spin={submitting} type="submit" />
                </Card.Footer>
            </form>
        </Card>
    )
}

export default ScheduleRelaunchContent